
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"17","height":"14","viewBox":"0 0 17 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.357 5.775L10.294.103c-.073-.068-.142-.107-.24-.103-.19.009-.43.142-.43.344V3.19a.184.184 0 01-.155.176C3.441 4.289.901 8.8.003 13.484c-.034.185.215.357.331.21 2.2-2.771 4.877-4.58 9.11-4.614.094 0 .18.111.18.206v2.793c0 .3.4.434.623.227l6.106-5.77a.475.475 0 00.15-.361c-.004-.138-.038-.297-.146-.4z","fill":"currentColor"}})])
          )
        }
      }
    